import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    document.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd)

    // Covers server-rendered error states on initial page load.
    this.scrollToFirstError()
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  handleSubmitEnd(event) {
    const { success } = event.detail || {}
    if (success) return

    const form = event.target
    if (!(form instanceof HTMLFormElement)) return

    requestAnimationFrame(() => {
      this.scrollToFirstError(form)
    })
  }

  scrollToFirstError(form = null) {
    const scope = form || this.element
    const errorNode = scope.querySelector(".field .error")
    if (!errorNode) return

    const field = errorNode.closest(".field")
    const input = field?.querySelector(
      "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled])",
    )

    const target = input || errorNode

    target.scrollIntoView({ behavior: "smooth", block: "center" })

    if (input) {
      input.focus({ preventScroll: true })
    } else {
      errorNode.setAttribute("tabindex", "-1")
      errorNode.focus({ preventScroll: true })
    }
  }
}
